module.exports = __webpack_public_path__ + "0c8f2970e3733c62763a1fa36f3e60c2.jpg";